import { MainFlow } from "../screens/flow";

const Flow = () => <MainFlow />;

export default Flow;
